<template>
  <common-page
    ref="commonPage"
    :bg-path="bgPath"
    :web-path="webPath"
    :columns="columns"
    :search-items="searchItems"
    :table-options="tableOptions"
    :form-items="formItems"
  />
</template>
<script>
export default {
  data() {
    return {
      // ===== ===== ===== ===== 全局属性 ===== ===== ===== =====
      // 后台接口路径
      bgPath: 'clinic/clinicdic/clinicmedicinedic/clinicmateriel',
      // Web路径
      webPath: 'base/dictionary/medicine_dic/materiel',
      tableOptions: ['synchronization'],
      // ===== ===== ===== ===== 页面配置 ===== ===== ===== =====
      // 搜索内容
      searchItems: [
        {
          rowIndex: 1,
          items: [
            {
              code: "code",
              name: "编码",
              span: 6,
              type: "text",
              config: {
                edit: false
              }
            },
            {
              code: "name",
              name: "名称",
              span: 6,
              type: "text",
              config: {
                edit: false
              }
            },
            {
              code: "materielTypeCode",
              name: "物料类型编码",
              type: "popup",
              span: 6,
              config: {
                url: "base/dictionary/medicinedic/materieltype",
                filedList: [
                  { code: 'id', name: 'Id' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: {},
                disabled: false
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateTitleData(code, row.code)
                  this.$refs.commonPage.updateTitleData("materielTypeName", row.name)
                  this.$refs.commonPage.updateTitleData("materielTypeId", row.id)
                }
              }
            },
            {
              code: "materielTypeName",
              name: "物料类型名称",
              span: 6,
              type: "text",
              config: {
                edit: false
              }
            },
            {
              code: "typeSign",
              name: "类型标识",
              span: 6,
              type: "select",
              config: {
                edit: false,
                options: [
                  { key: "1", value: "中成药" },
                  { key: "2", value: "西药" },
                  { key: "3", value: "饮片" },
                  { key: "4", value: "服务" },
                  { key: "5", value: "产品" }
                ]
              }
            },
            {
              code: "medUomCode",
              name: "药品单位编码",
              type: "popup",
              span: 6,
              config: {
                url: "base/dictionary/medicinedic/meddictionary",
                filedList: [
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: { medDirectoryCode: "DW" },
                defaultValue: "",
                minLength: 0,
                maxLength: 20,
                disabled: false
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateTitleData(code, row.code)
                  this.$refs.commonPage.updateTitleData("medUomName", row.name)
                  this.$refs.commonPage.updateTitleData("medUomId", row.id)
                }
              }
            },
            {
              code: "medUomName",
              name: "药品单位名称",
              type: "text",
              span: 6,
              config: {
                edit: false
              }
            },
            {
              code: "medSpecCode",
              name: "药品规格编码",
              type: "popup",
              span: 6,
              config: {
                url: "base/dictionary/medicinedic/meddictionary",
                filedList: [
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: { medDirectoryCode: "DW" },
                defaultValue: "",
                minLength: 0,
                maxLength: 20,
                disabled: false
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateTitleData(code, row.code)
                  this.$refs.commonPage.updateTitleData("medSpecName", row.name)
                  this.$refs.commonPage.updateTitleData("medSpecId", row.id)
                }
              }
            },
            {
              code: "medSpecName",
              name: "药品规格名称",
              type: "text",
              span: 6,
              config: {
                edit: false
              }
            },
            {
              code: "medDosageCode",
              name: "药品剂型编码",
              type: "popup",
              span: 6,
              config: {
                url: "base/dictionary/medicinedic/meddictionary",
                filedList: [
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: { medDirectoryCode: "XJ" },
                defaultValue: "",
                minLength: 0,
                maxLength: 20,
                disabled: false
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateTitleData(code, row.code)
                  this.$refs.commonPage.updateTitleData("medDosageName", row.name)
                  this.$refs.commonPage.updateTitleData("medDosageId", row.id)
                }
              }
            },
            {
              code: "medDosageName",
              name: "药品剂型名称",
              type: "text",
              span: 6,
              config: {
                edit: false
              }
            },
            {
              code: "meaUomCode",
              name: "计量单位编码",
              type: "popup",
              span: 6,
              config: {
                url: "base/dictionary/medicinedic/meddictionary",
                filedList: [
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: { medDirectoryCode: "JLDW" },
                defaultValue: "",
                minLength: 0,
                maxLength: 20,
                disabled: false
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateTitleData(code, row.code)
                  this.$refs.commonPage.updateTitleData("meaUomName", row.name)
                  this.$refs.commonPage.updateTitleData("meaUomId", row.id)
                }
              }
            },
            {
              code: "meaUomName",
              name: "计量单位名称",
              type: "text",
              span: 6,
              config: {
                edit: false
              }
            },
            {
              code: "classifyUomCode",
              name: "物料分类编码",
              type: "popup",
              span: 6,
              config: {
                url: "base/dictionary/medicinedic/classifydictionary",
                filedList: [
                  { code: 'id', name: 'Id' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                disabled: false
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateTitleData(code, row.code)
                  this.$refs.commonPage.updateTitleData("classifyUomName", row.name)
                  this.$refs.commonPage.updateTitleData("classifyUomId", row.id)
                }
              }
            },
            {
              code: "classifyUomName",
              name: "物料分类名称",
              span: 6,
              type: "text",
              config: {
                edit: false
              }
            }
          ]
        }
      ],
      // 列表内容
      columns: [
        {
          code: "code",
          name: "编码",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "name",
          name: "名称",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "materielTypeCode",
          name: "物料类型编码",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "materielTypeName",
          name: "物料类型名称",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "typeSign",
          name: "类型标识",
          span: 6,
          type: "select",
          config: {
            edit: false,
            options: [
              { key: "1", value: "中成药" },
              { key: "2", value: "西药" },
              { key: "3", value: "饮片" },
              { key: "4", value: "服务" },
              { key: "5", value: "产品" }
            ]
          }
        },
        {
          code: "medUomCode",
          name: "药品单位编码",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "medUomName",
          name: "药品单位名称",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "medSpecCode",
          name: "药品规格编码",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "medSpecName",
          name: "药品规格名称",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "medDosageCode",
          name: "药品剂型编码",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "medDosageName",
          name: "药品剂型名称",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "meaUomCode",
          name: "计量单位编码",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "meaUomName",
          name: "计量单位名称",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "classifyUomCode",
          name: "物料分类编码",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "classifyUomName",
          name: "物料分类名称",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        }
      ],
      // 增加/修改/详情 表单
      formItems: [
        {
          rowIndex: 1,
          items: [
            {
              code: "code",
              name: "编码",
              span: 6,
              type: "text",
              config: {
                edit: false,
                rules: [
                  { required: true, message: "请输入编码", trigger: "blur" }
                ]
              }
            },
            {
              code: "name",
              name: "名称",
              span: 6,
              type: "text",
              config: {
                edit: false,
                rules: [
                  { required: true, message: "请输入名称", trigger: "blur" }
                ]
              }
            },
            {
              code: "materielTypeCode",
              name: "物料类型编码",
              type: "popup",
              span: 6,
              config: {
                url: "base/dictionary/medicinedic/materieltype",
                filedList: [
                  { code: 'id', name: 'Id' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: {},
                disabled: false,
                rules: [
                  { required: true, message: '请选择物料类型', trigger: 'change' }
                ]
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateFormData(code, row.code)
                  this.$refs.commonPage.updateFormData("materielTypeName", row.name)
                  this.$refs.commonPage.updateFormData("materielTypeId", row.id)
                }
              }
            },
            {
              code: "materielTypeName",
              name: "物料类型名称",
              span: 6,
              type: "text",
              config: {
                edit: false,
                disabled: true
              }
            },
            {
              code: "typeSign",
              name: "类型标识",
              span: 6,
              type: "select",
              config: {
                edit: false,
                defaultValue: '1',
                options: [
                  { key: "1", value: "中成药" },
                  { key: "2", value: "西药" },
                  { key: "3", value: "饮片" },
                  { key: "4", value: "服务" },
                  { key: "5", value: "产品" }
                ]
              }
            },
            {
              code: "medUomCode",
              name: "药品单位编码",
              type: "popup",
              span: 6,
              config: {
                url: "base/dictionary/medicinedic/meddictionary",
                filedList: [
                  { code: 'id', name: 'Id' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: {
                  medDirectoryCode: "DW"
                },
                disabled: false,
                rules: [
                  { required: true, message: '请选择药品单位', trigger: 'change' }
                ]
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateFormData(code, row.code)
                  this.$refs.commonPage.updateFormData("medUomName", row.name)
                  this.$refs.commonPage.updateFormData("medUomId", row.id)
                }
              }
            },
            {
              code: "medUomName",
              name: "药品单位名称",
              span: 6,
              type: "text",
              config: {
                edit: false,
                disabled: true
              }
            },
            {
              code: "medSpecCode",
              name: "药品规格编码",
              type: "popup",
              span: 6,
              config: {
                url: "base/dictionary/medicinedic/meddictionary",
                filedList: [
                  { code: 'id', name: 'Id' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: {
                  medDirectoryCode: "DW"
                },
                disabled: false,
                rules: [
                  { required: true, message: '请选择药品规格', trigger: 'change' }
                ]
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateFormData(code, row.code)
                  this.$refs.commonPage.updateFormData("medSpecName", row.name)
                  this.$refs.commonPage.updateFormData("medSpecId", row.id)
                }
              }
            },
            {
              code: "medSpecName",
              name: "药品规格名称",
              span: 6,
              type: "text",
              config: {
                edit: false,
                disabled: true
              }
            },
            {
              code: "medDosageCode",
              name: "药品剂型编码",
              type: "popup",
              span: 6,
              config: {
                url: "base/dictionary/medicinedic/meddictionary",
                filedList: [
                  { code: 'id', name: 'Id' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: {
                  medDirectoryCode: "XJ"
                },
                disabled: false,
                rules: [
                  { required: true, message: '请选择药品剂型', trigger: 'change' }
                ]
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateFormData(code, row.code)
                  this.$refs.commonPage.updateFormData("medDosageName", row.name)
                  this.$refs.commonPage.updateFormData("medDosageId", row.id)
                }
              }
            },
            {
              code: "medDosageName",
              name: "药品剂型名称",
              span: 6,
              type: "text",
              config: {
                edit: false,
                disabled: true
              }
            },
            {
              code: "meaUomCode",
              name: "计量单位编码",
              type: "popup",
              span: 6,
              config: {
                url: "base/dictionary/medicinedic/meddictionary",
                filedList: [
                  { code: 'id', name: 'Id' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: {
                  medDirectoryCode: "DW"
                },
                disabled: false,
                rules: [
                  { required: true, message: '请选择计量单位', trigger: 'change' }
                ]
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateFormData(code, row.code)
                  this.$refs.commonPage.updateFormData("meaUomName", row.name)
                  this.$refs.commonPage.updateFormData("meaUomId", row.id)
                }
              }
            },
            {
              code: "meaUomName",
              name: "计量单位名称",
              span: 6,
              type: "text",
              config: {
                edit: false,
                disabled: true
              }
            },
            {
              code: "classifyUomCode",
              name: "物料分类编码",
              type: "popup",
              span: 6,
              config: {
                url: "base/dictionary/medicinedic/classifydictionary",
                filedList: [
                  { code: 'id', name: 'Id' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                disabled: false,
                rules: [
                  { required: true, message: '请选择物料分类', trigger: 'change' }
                ]
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateFormData(code, row.code)
                  this.$refs.commonPage.updateFormData("classifyUomName", row.name)
                  this.$refs.commonPage.updateFormData("classifyUomId", row.id)
                }
              }
            },
            {
              code: "classifyUomName",
              name: "物料分类名称",
              span: 6,
              type: "text",
              config: {
                edit: false,
                disabled: true
              }
            }
          ]
        }
      ]
    }
  }
}
</script>
